import * as React from 'react'
import {Link} from '@portal/arq-portal-core';
import { makeStyles, Typography } from '@material-ui/core';

import { BuzonesProps } from '../types/types';

export const Buzones = (props: BuzonesProps) => { //props:any

    const useStyles = makeStyles(theme => ({
        linea: {
        padding: theme.spacing(1)
        }, 
        listItem: {
            display: 'flex',
            flexDirection: 'column', 
            padding: '15px',
            paddingBottom: '30px',
            backgroundColor: 'white'
        }, 
        item:{
            borderBottom: '1px solid #d6d8d8',
            fontSize: '12px',
            color: '#606060',
            fontFamily: "Catalana-sans",
            cursor: 'pointer',
            display: 'flex',
            padding: '6px 0',
            alignItems: 'center',
            justifyContent: 'space-between',
            '&:hover':{
                color: '#919191',
            },
            '&:focus, &:active':{
                color: '#DC0028',
            }
        }
    }));

    const classes = useStyles(props);
    
    return (
    <div className = {classes.listItem}>
       {props.datos.map ((item) => <Link className={classes.item} to = {item.Url}><Typography style={{flex: "1"}} variant="inherit">{item.Titulo}</Typography></Link>)}
    </div>
    );
}